export default {
  'users.title': 'Manage Users',
  'users.userGroup': 'User Groups',
  'users.title.detail': 'DETAIL',
  'users.extraUserFields': 'Extra User Fields',

  'users.form.email': 'Email',
  'users.form.names': 'Names',
  'users.form.lastNames': 'Last Names',
  'users.form.mobilePhone': 'Mobile phone',
  'users.form.roles': 'Roles',
  'users.form.positionId': 'Position',
  'users.form.userBossId': 'Boss',
  'users.form.accessType': 'Access Type',
  'users.form.isActive': 'Is Active',

  'users.form.selectGroup': 'Select a group',
  'users.form.selectUser': 'Select a user',
  'users.mixed': 'Mixed',
  'users.userandpassword': 'Username and Password',
  'users.office365': 'Office365',
  'users.google': 'Google',
  'users.automy': 'AUTOMY',

  'users.config.name': 'Name',
  'users.form.selectEnviroment': 'Select the environment',
  'users.form.environmentIds.loginHint':
    'If you do not select an environment, this person will not be able to sign in until they have an accessible environment',

  'users.userGroupExists': 'Already assigned to that user group',
  'users.environmentExists': 'Already assigned to that environment',
  'users.form.twoFactorEnabled': 'Two-Factor Authentication Enabled?',
  'users.column.twoFactorEnabled': '2FA',
  'users.bulk.enableTwoFactor': 'Enable two-factor authentication',
  'users.bulk.disableTwoFactor': 'Disable two-factor authentication',
  'users.selectedElements': 'selected elements',
  'users.selectedElement': 'selected element',
  'users.environmentsTitle': 'User Environments',
  'users.userGroups.description': 'Manage the user groups assigned to {name}.',
  'users.userEnvironments.description': 'Manage the environments assigned to {name}.',
  'users.resetPassword.title': 'Reset Password',
  'users.resetPassword.description': 'Define a new password for {name}.',
  'users.import.restore.confirmCount': 'Do you want to restore the {count} selected users?',

  'users.changeEmail.action': 'Change email',
  'users.changeEmail.banner':
    'This user signs in with an email different from the one shown here. Update it so they are the same.',
  'users.changeEmail.directory': 'Email',
  'users.changeEmail.access': 'Sign-in email',
  'users.changeEmail.noAccess': 'This user has no sign-in email',
  'users.changeEmail.helper': 'When you save, the user is left with the email you choose.',
  'users.changeEmail.twoFactor':
    'Changing the sign-in email requires setting up the authenticator again.',
};
